import React from 'react';

const StagingBanner = () => {
  // Only show on staging environment
  if (window.location.hostname !== 'staging.fitflow.younitefitness.co.nz') {
    return null;
  }

  return (
    <div className="staging-banner">
      <div className="staging-banner-content">
        <div className="staging-banner-icon">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="staging-banner-text">
          <span className="staging-banner-title">STAGING ENVIRONMENT</span>
          <span className="staging-banner-subtitle">STAGING SITE - data may be reset</span>
        </div>
        <div className="staging-banner-indicator">
          <div className="staging-banner-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default StagingBanner;
